import React from "react"
import styled from "styled-components"
import { translate } from "react-i18next"
import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import { connect } from "react-redux"
import { withRouter } from "react-router"

import ScrollableViewWithTabs from "../../components/ScrollableViewWithTabs"
import PersonalInfo from "./PersonalInfo"
import AllInfo from "./AllInfo"
import { setHeaderTitle, setTheme } from "../../store/action"
import WithLogin from "../../components/WithLogin"
import i18n from "../../i18n"
import config from "../../Config"
import ProfileInfo from "./ProfileInfo"
//import Header from "./../Header";

const Header = styled.div`
  display: flex;
  height: 56px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0px 20px;
`

const Container = styled.div`
  height: 100%;
  overflow: hidden;
`

const Label = styled.span`
  font-family: montserratRegular;
  font-size: 16px;
  font-weight: 500;
  margin-left: 20px;
  flex: 3;
  text-align: left;
`

class MyAccount extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
    }
    this.editForm = this.editForm.bind(this)
    this.backToAccount = this.backToAccount.bind(this)
  }

  componentDidMount() {
    console.log("account index")
    const getSkin = async () => {
      // const response = await fetch(`http://${host}/skinTheam`)
      const response = await fetch(`${config.NETWORK_URL}/skin`)
      console.log("skin response", response)
      const json = await response.json()
      console.log("skin json", json)
      localStorage.setItem("skinTheme", JSON.stringify(json))
      this.props.setTheme(json)
    }
    getSkin()
  }

  componentWillMount() {
    const { history, setHeaderTitle } = this.props
    console.log("account index")

    const getSkin = async () => {
      // const response = await fetch(`http://${host}/skinTheam`)
      const response = await fetch(`${config.NETWORK_URL}/skin`)
      console.log("skin response", response)
      const json = await response.json()
      console.log("skin json", json)
      localStorage.setItem("skinTheme", JSON.stringify(json))
      this.props.setTheme(json)
    }
    getSkin()
    /*setHeaderTitle(i18n.t("My Account"))
     history.replace({
        pathname: '/play/',
        state: {}
     });*/
  }

  editForm() {
    this.setState({ edit: true })
    console.log("ediitt")
  }

  backToAccount() {
    this.setState({ edit: false })
  }

  render() {
    const { t, history, theme } = this.props
    const { edit } = this.state
    console.log("ACCOUNT : ", this.state)
    console.log("ACCOUNT : ", this.props)
    return (
      <Container style={{ backgroundColor: theme.primaryColor }}>
        <Header>
          <img
            onClick={edit ? this.backToAccount : () => history.push(`/play/`)}
            className='arrow'
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/arrow_back.svg`}
            alt='back-arrow'
            style={{ cursor: "pointer" }}
          />
          {/* <Label>{i18n.t("MyAccount")}</Label> */}
          <Label>{edit ? i18n.t("EditMyProfile") : i18n.t("MyProfile")}</Label>
        </Header>
        {/* <ScrollableViewWithTabs
          tabConfig={[
            { label: t("AccountInfo") },
            { label: t("PersonalInfo") },
          ]}
        >
          <AllInfo t={t} />
          <PersonalInfo t={t} />
        </ScrollableViewWithTabs> */}
        {/* <ProfileInfo /> */}
        <AllInfo t={t} edit={edit} onEditClick={this.editForm} />
      </Container>
    )
  }
}

export default (MyAccount = connect(
  (state, ownProps) => {
    return {
      data: get(state, "data.homeData.userProfile"),
      homeData: get(state, "data.homeData"),
      theme: state.theme,
    }
  },
  {
    setHeaderTitle,
    setTheme,
  }
)(withRouter(translate("translations")(WithLogin(MyAccount)))))



// WEBPACK FOOTER //
// ./src/views/MyAccount/index.js